// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._bfhk3nif{background-color:var(--ds-background-neutral-subtle,#101214)}\n._lswu1fjw{fill:var(--ds-icon-success,#101214)}\n._syaz13q9{color:var(--_1qpk0k2)}\n._30l313q9:hover{color:var(--_1qpk0k2)}\n._irr3ebx2:hover{background-color:var(--ds-background-neutral-subtle-hovered,#a1bdd914)}._1di6j4ot:active{background-color:var(--ds-background-neutral-subtle-pressed,#a6c5e229)}\n._9h8h13q9:active{color:var(--_1qpk0k2)}", ""]);
// Exports
module.exports = exports;
